import cookies from './cookies';
import { UserDictionary } from '../sso/types/UserDictionary';
import UserAccount from 'shared/sharedTypes/account/UserAccount';
import { ServerEnv } from 'shared/sharedTypes/common/misc';
import { RenderMenuParams } from './components/FFMenuV2/RenderMenuParams';

export type CurrentUser = Partial<Omit<UserAccount, 'fullname'>> & {
    fullName?: string; //backend/common/account/UserFlags.ts:L32
    accountPath?: string[];
    prettyName2?: string;
    isOrgBillingAdmin?: boolean;
    isOrgOwner?: boolean;
    isGroupOwner?: boolean;
    isInvoiceAdmin?: boolean;
    isOrgAircraftAdmin?: boolean;
    isParent?: boolean;
    isChild?: boolean;
    isCorporate?: boolean;
    isCompanyDispatcher?: boolean;
    isUasCustomer?: boolean;
    isEmployee?: boolean;
    isWebDev?: boolean;
    isDataTeam?: boolean;
    performance_planning?: boolean;
    isBetaTeam?: boolean;
    vectormap_eu?: boolean;
    enterprise_planning?: boolean;
    hasDirectory?: boolean;
    hasRoster?: boolean;
    tethered_downloads?: boolean;
    content_packs?: boolean;
    hasOTS?: boolean;
    hasNavlogOfp?: boolean;
    isOrgMember?: boolean;
    sub_organizations?: boolean;
    isOrgUserAdmin?: boolean;
    isOrgJeppAdmin?: boolean;
    hasJeppesenAccess?: boolean;
    isOrgIntegrationsAdmin?: boolean;
    isOrgDocumentsAdmin?: boolean;
    isOneDriveBeta?: boolean;
    documents?: boolean;
    enterprise_documents?: boolean;
    dispatch_tools?: boolean;
    dispatch_lowca?: boolean;
    dispatch_fdpx?: boolean;
    jeppesen_ma_dispatch?: boolean;
    dispatch_role_access?: boolean;
    hasDispatchLowca?: boolean;
    hasJeppesenMaDispatch?: boolean;
    custom_content?: boolean;
    isPerTailAdmin?: boolean;
    isUserAllocationAdmin?: boolean;
    isMfbInternational?: boolean;
    raim_prediction?: boolean;
    reserve_fuel_policy?: boolean;
    jetfuelx?: boolean;
    isOrgJfxEditor?: boolean;
    data_ca?: boolean;
    comply?: boolean;
    fspAdminUuid?: string;
    isFF_FspAdmin?: boolean;
    mfb?: boolean;
    mfb_one?: boolean;
    mfb_one_intl?: boolean;
    canSync?: boolean;
    isFspAdmin?: boolean;
    isFsp?: boolean;
    hasPerUserLicense?: boolean;
    weightbalance_flights?: boolean;
    weightbalance_flts?: boolean;
    // Runway Analysis Feature Flags
    jeppesen_runway_analysis?: boolean;
    runway_analysis_tools?: boolean;
    rwa_all?: boolean;
    runway_analysis_cessnaaircraft_510citationmustang?: boolean;
    runway_analysis_cessnaaircraft_525citationm2?: boolean;
    runway_analysis_cessnaaircraft_525bcitationcj3?: boolean;
    'runway_analysis_cessnaaircraft_525bcitationcj3+'?: boolean;
    runway_analysis_cessnaaircraft_525ccitationcj4?: boolean;
    runway_analysis_cessnaaircraft_680acitationlatitude?: boolean;
    'runway_analysis_cessnaaircraft_560citationxls+'?: boolean;
    runway_analysis_bombardier_challenger300?: boolean;
    runway_analysis_bombardier_challenger604?: boolean;
    runway_analysis_bombardier_challenger605?: boolean;
    runway_analysis_bombardier_challenger650?: boolean;
    runway_analysis_bombardierlearjet_learjet75?: boolean;
    runway_analysis_gulfstreamaerospace_giv?: boolean;
    runway_analysis_gulfstreamaerospace_g500gvsp?: boolean;
    runway_analysis_gulfstreamaerospace_g550gvsp?: boolean;
    runway_analysis_gulfstreamaerospace_g650?: boolean;
    runway_analysis_gulfstreamaerospace_g650er?: boolean;
    runway_analysis_gulfstreamaerospace_g500?: boolean;
    runway_analysis_gulfstreamaerospace_g600?: boolean;
    pooleys_ie_aip?: boolean;
    pooleys_uk_aip?: boolean;
    weightbalance_legacy?: boolean;
    icing_turbulence_surface?: boolean;
    clouds?: boolean;
    vectormap?: boolean;
    data_us?: boolean;
    data_eu?: boolean;
    data_au?: boolean;
    data_la?: boolean;
    data_af?: boolean;
    ans_fi_vfr?: boolean;
    avinor_no_vfr?: boolean;
    ign_fr_vfr?: boolean;
    lfv_se_vfr?: boolean;
    nats_uk_vfr?: boolean;
    avioportolano_it_vfr?: boolean;
    cartabossy_vfr?: boolean;
    military_training_routes?: boolean;
    aerial_refueling?: boolean;
    isFspFlightManager?: boolean;
    isOrgFlightsAdmin?: boolean;
    honeywell_forge_link?: boolean;
    flight_service_provider?: boolean,
    managedUsername?: boolean,
    cahoy_pfoqa?: boolean,
    flight_tracking?: boolean,
    flight_tracking_global?: boolean,
    mil_flight_tracking_standard?: boolean,
    mil_flight_tracking_enhanced?: boolean,
    mil_flight_tracking_premium?: boolean,
    hasCATrackingLicense?: boolean,
    ca_flight_tracking_essential?: boolean;
    ca_flight_tracking_preferred?: boolean;
    filing_dispatchers_only?: boolean
    easa_compliance?: boolean
    isProSupport?: boolean;
    isPremiumSupport?: boolean;
    reseller_customer?: boolean;
    enterprise?: boolean;
    // BA platform-tier flags
    ba_level_single_tail?: boolean;
    ba_level_teams?: boolean;
    isLegacyAccount?: boolean;
    hasSmartGroups?: boolean;
    basic_plus?: boolean;
    pro_plus?: boolean;
    performance_plus?: boolean;
    business_pro?: boolean;
    business_performance?: boolean;
    mfb_pro?: boolean;
    mfb_performance?: boolean;
    mfb_pro_intl?: boolean;
    mfb_perf_intl?: boolean;
    // flitebrief and flitelink licenses are deprecated and will be removed once new licenses are in prod - OA
    flitebrief?: boolean;
    flitelink?: boolean;
    flitelink_essential?: boolean;
    flitelink_preferred?: boolean;
    ais_jp100_vfr?: boolean;
    ais_jp250_vfr?: boolean;
    ais_jp500_vfr?: boolean;
    data_nz?: boolean;
    hasInsurance?: boolean;
    hasInsuranceOwnerQuoting?: boolean;
    ent_sso?: boolean;
    charts_jepp_toolkit?: boolean;
    fsp_tier2?: boolean;
    isFspViewer?: boolean;
    hasDebrief?: boolean;
    dynamic_procedures_group_enablement?: boolean;
    isInSubOrg?: boolean;
    licenseReportedTurbulenceAll?: boolean;
    licenseReportedTurbulenceLowAlt?: boolean;
    hasAnyReportedTurbulence?: boolean;
    hasNonMiniSentries?: boolean;
    hasTrackingRole?: boolean;
    frat?: boolean;
    wb_use_dry_operating_weight?: boolean;
    isSafetyManager?: boolean;
    hasSms?: boolean;
    isLb4lUser?: boolean;
    trip_planner?: boolean;
    driftdown_and_escape_routes?: boolean;
    pacman?: boolean;
};

export type User = CurrentUser;
export type Account = User;  // There are different types of Accounts, not just Users.
export type Organization = Account;

declare global {
    interface Window {
        currentUser?: CurrentUser;
        serverEnv?: ServerEnv;
        featureFlags?: { [key: string]: boolean };
        theme?: string;
        userDict?: UserDictionary;
        timezoneSetting?: string
        initializedNavMenuState?: RenderMenuParams["initialize"]["initializedState"];
        navMenuSizeLocked: RenderMenuParams["initialize"]["navMenuSizeLocked"];
        fspUser?: CurrentUser;
    }
}

export function getUserDictionary() {
    return (window && window.userDict) || ({} as UserDictionary);
}
export function uas(currentTheme?: string) {
    const theme = currentTheme || (window && window.theme) || null;
    return !!(
        theme &&
        typeof theme.toLowerCase === 'function' &&
        theme.toLowerCase() === 'uas'
    );
}

export function getAccountPath(currentUser?: CurrentUser) {
    const user: Partial<User> =
        currentUser || (window && window.currentUser) || null;
    return user && user.accountPath;
}

export function getAccountUuid(currentUser?: CurrentUser) {
    const user: Partial<User> = currentUser || (window && window.currentUser) || null;
    return user && user.accountUuid;
}

export function getParentUuid(currentUser?: CurrentUser) {
    const user: Partial<User> = currentUser || (window && window.currentUser) || null;
    return user && user.parentUuid;
}

export function getPrettyName(currentUser?: CurrentUser) {
    const user: Partial<User> = currentUser || (window && window.currentUser) || null;
    return user && user.prettyName2;
}

export function isOrgOwner(currentUser?: CurrentUser) {
    const user: Partial<User> = currentUser || (window && window.currentUser) || null;
    return !!(user && user.isOrgOwner);
}

export function isGroupOwner(currentUser?: CurrentUser) {
    const user: Partial<User> = currentUser || (window && window.currentUser) || null;
    return !!(user && user.isGroupOwner);
}

export function isOrgAircraftAdmin(currentUser?: CurrentUser) {
    const user: Partial<User> = currentUser || (window && window.currentUser) || null;
    return !!(user && user.isOrgAircraftAdmin);
}

export function isOrgIntegrationsAdmin(currentUser?: CurrentUser) {
    const user: Partial<User> = currentUser || (window && window.currentUser) || null;
    return !!(user && user.isOrgIntegrationsAdmin);
}

export function hasDocuments(currentUser?: CurrentUser) {
    const user: Partial<User> = currentUser || (window && window.currentUser) || null;
    return !!(user && user.documents);
}

export function hasEnterpriseDocuments(currentUser?: CurrentUser) {
    const user: Partial<User> = currentUser || (window && window.currentUser) || null;
    return !!(user && user.enterprise_documents);
}

export function hasSmartGroups(currentUser?: CurrentUser) {
    const user: Partial<User> = currentUser || (window && window.currentUser) || null;
    return !!(user && user.hasSmartGroups);
}

export function hasEnterprise(currentUser?: CurrentUser) {
    const user: Partial<User> = currentUser || (window && window.currentUser) || null;
    return !!(user && user.enterprise); // enterprise is equivalent to the "control tower" license
}

export function hasSsoEnt(currentUser?: CurrentUser) {
    const user: Partial<User> = currentUser || (window && window.currentUser) || null;
    return !!(user && user.ent_sso);
}

export function isOrgDocumentsAdmin(currentUser?: CurrentUser) {
    const user: Partial<User> = currentUser || (window && window.currentUser) || null;
    return !!(user && user.isOrgDocumentsAdmin);
}

export function isOrgBillingAdmin(currentUser?: CurrentUser) {
    const user: Partial<User> = currentUser || (window && window.currentUser) || null;
    return !!(user && user.isOrgBillingAdmin);
}

export function isOneDriveBeta(currentUser?: CurrentUser) {
    const user: Partial<User> = currentUser || (window && window.currentUser) || null;
    return !!(user && user.isOneDriveBeta);
}

export function isParentAccount(currentUser?: CurrentUser) {
    const user: Partial<User> = currentUser || (window && window.currentUser) || null;
    return !!(user && user.isParent);
}

export function isChildAccount(currentUser?: CurrentUser) {
    const user: Partial<User> = currentUser || (window && window.currentUser) || null;
    return !!(user && user.isChild);
}

export function isCorporate(currentUser?: CurrentUser) {
    const user: Partial<User> = currentUser || (window && window.currentUser) || null;
    return !!(user && user.isCorporate);
}

export function isCompanyDispatcher(currentUser?: CurrentUser) {
    const user: Partial<User> = currentUser || (window && window.currentUser) || null;
    return !!(user && user.isCompanyDispatcher);
}

export function isMfbUser(currentUser?: CurrentUser) {
    const user: Partial<User> = currentUser || (window && window.currentUser) || null;
    if (!user) return false;
    return !!user.mfb;
}

export function isMfbOneUser(currentUser?: CurrentUser) {
    const user: Partial<User> = currentUser || (window && window.currentUser) || null;
    if (!user) return false;
    return !!user.mfb_one;
}

export function hasMfbPerfAndOne(currentUser?: CurrentUser) {
    const user: Partial<User> = currentUser || (window && window.currentUser) || null;
    if (!user) return false;
    return !!(user.mfb_performance || user.mfb_one);
}

export function isUasCustomer(currentUser?: CurrentUser) {
    const user: Partial<User> = currentUser || (window && window.currentUser) || null;
    return !!(user && user.isUasCustomer);
}

export function isEmployee(currentUser?: CurrentUser) {
    const user: Partial<User> = currentUser || (window && window.currentUser) || null;
    return !!(user && user.isEmployee);
}

export function isWebDev(currentUser?: CurrentUser) {
    const user: Partial<User> = currentUser || (window && window.currentUser) || null;
    return !!(user && user.isWebDev);
}

export function isDataTeam(currentUser?: CurrentUser) {
    const user: Partial<User> = currentUser || (window && window.currentUser) || null;
    return !!(user && user.isDataTeam);
}

export function canRunPerformance(currentUser?: CurrentUser) {
    const user: Partial<User> = currentUser || (window && window.currentUser) || null;
    return !!(user && user.performance_planning);
}

export function isBetaTeam(currentUser?: CurrentUser) {
    const user: Partial<User> = currentUser || (window && window.currentUser) || null;
    return !!(user && user.isBetaTeam);
}

export function hasVectorEU(currentUser?: CurrentUser) {
    const user: Partial<User> = currentUser || (window && window.currentUser) || null;
    return !!(user && user.vectormap_eu);
}

export function hasWeightBalance(currentUser?: CurrentUser) {
    const user: Partial<User> = currentUser || (window && window.currentUser) || null;
    return !!(user && (user.weightbalance_flights || user.weightbalance_flts))
}

export function hasTripPlanner(currentUser?: CurrentUser) {
    const user: Partial<User> = currentUser || (window && window.currentUser) || null;
    return !!(user && (user.trip_planner))
}

export function hasForcedWBLegacy(currentUser?: CurrentUser) {
    const user: Partial<User> = currentUser || (window && window.currentUser) || null;
    return !!(user && user.weightbalance_legacy)
}

export function hasJeppesenAccess(currentUser?: CurrentUser) {
    const user: Partial<User> = currentUser || (window && window.currentUser) || null;
    return !!(user && user.hasJeppesenAccess);
}

export function hasJeppChartsAccess(currentUser?: CurrentUser) {
    const user: Partial<User> = currentUser || (window && window.currentUser) || null;
    return !!(user && user.hasJeppesenAccess && user.charts_jepp_toolkit);
}

// Most of the time the functions is used to determine if the fspUser obj has fsp_tier2. For that reason
// we want passing in of `undefined` to be seen as false.
// If we used a default parameter of currentUser, like done with other functions here, then when passing in
// an undefined fspUser, then it would use currentUser, which if the currentUser is fsp_tier2,
// then all the fsp_tier2 stuff would be visible, even though it doesn't make sense on their own account.
export function hasFspTier2(user: CurrentUser) {
    return user && Boolean(user?.fsp_tier2);
}

/**
 * Enterprise planning can loosely be thought of as UAS-features that are can
 * be exposed outside of UAS as a Commercial or Enterprise level of planning a
 * flight. See SVR-1550, WEB-1082.
 */
export function hasEnterprisePlanning(currentUser?: CurrentUser) {
    const user: Partial<User> = currentUser || (window && window.currentUser) || null;
    return !!(user && user.enterprise_planning);
}

export function canUseAdvancedRouteAdvisorConstraints(
    currentUser?: CurrentUser
) {
    return canRunPerformance(currentUser) || hasEnterprisePlanning(currentUser);
}

export function hasDirectory(currentUser?: CurrentUser) {
    const user: Partial<User> = currentUser || (window && window.currentUser) || null;
    return !!(user && user.hasDirectory);
}
export function hasRoster(currentUser?: CurrentUser) {
    const user: Partial<User> = currentUser || (window && window.currentUser) || null;
    return !!(user && user.hasRoster);
}
export function hasTetheredDownloads(currentUser?: CurrentUser) {
    const user: Partial<User> = currentUser || (window && window.currentUser) || null;
    return !!(user && user.tethered_downloads);
}
/**
 * Whether user has Organized Track System (sometimes referred to as NATS, or
 * NAT Tracks). See SVR-1550 and WEB-1090
 */
export function hasOTS(currentUser?: CurrentUser) {
    const user: Partial<User> = currentUser || (window && window.currentUser) || null;
    return !!(user && user.hasOTS);
}

export function hasNavlogOfp(currentUser?: CurrentUser) {
    const user: Partial<User> = currentUser || (window && window.currentUser) || null;
    return !!(user && user.hasNavlogOfp);
}

export function getServerEnv(serverEnv?: ServerEnv) {
    const se = serverEnv || (window && window.serverEnv) || null;
    return se ? se : '';
}

export function getOrganizationId(currentUser?: CurrentUser) {
    const user: Partial<User> = currentUser || (window && window.currentUser) || null;
    if (user.isOrgMember && user.parentUuid) {
        // The check of the isOrgMember is required because it is based off
        // of looking at any defined parent uuid, and making sure that the
        // parent account type is actually an 'org' type.
        return user.parentUuid;
    } else if (user.isOrgUserAdmin) {
        // This is primarily for legacy org admins. They do not have a
        // parentUuid and can look very similar to regular single pilot users
        // except for the isOrgUserAdmin field being true.
        return user.parentUuid ?? user.accountUuid;
    }
    return null;
}

export function isOrgMember(currentUser?: CurrentUser) {
    const user: Partial<User> = currentUser || (window && window.currentUser) || null;
    return !!(user && user.isOrgMember);
}

export function sub_organizations(currentUser?: CurrentUser) {
    const user: Partial<User> = currentUser || (window && window.currentUser) || null;
    return !!(user && user.sub_organizations);
}

export function isOrgUserAdmin(currentUser?: CurrentUser) {
    const user: Partial<User> = currentUser || (window && window.currentUser) || null;
    return !!(user && user.isOrgUserAdmin);
}

export function isSubOrgAdmin(currentUser?: CurrentUser) {
    const user: Partial<User> = currentUser || (window && window.currentUser) || null;
    return !!(user.isOrgUserAdmin && !user.isOrgOwner);
}

export function isOrgJeppAdmin(currentUser?: CurrentUser) {
    const user: Partial<User> = currentUser || (window && window.currentUser) || null;
    return !!(user && user.isOrgJeppAdmin);
}

export function hasDispatchTools(currentUser?: CurrentUser) {
    const user: Partial<User> = currentUser || (window && window.currentUser) || null;
    return !!(user && user.dispatch_tools);
}

export function hasDriftDown(currentUser?: CurrentUser) {
    const user: Partial<User> = currentUser || (window && window.currentUser) || null;
    return !!(user && user.driftdown_and_escape_routes);
}

export function hasDispatchLowca(currentUser?: CurrentUser) {
    const user: Partial<User> = currentUser || (window && window.currentUser) || null;
    return !!(user && user.dispatch_lowca);
}

export function hasDispatchFdpx(currentUser?: CurrentUser) {
    const user: Partial<User> = currentUser || (window && window.currentUser) || null;
    return !!(user && user.dispatch_fdpx);
}

export function hasJeppesenMaDispatch(currentUser?: CurrentUser) {
    const user: Partial<User> = currentUser || (window && window.currentUser) || null;
    return !!(user && user.jeppesen_ma_dispatch);
}

/**
 * Check if the user has any of the subscriptions that allow for custom content menu item
 * Allow access for:
 * - dispatch_tools or custom_content licenses
 * - custom_content if the feature flag is enabled (Control Tower and Ops Manager)
 * @param currentUser User to check
 */
export function hasCustomContentMenuItem (currentUser: CurrentUser) {
    return currentUser?.dispatch_tools || currentUser?.custom_content;
}

export function isPerTailAdmin(currentUser?: CurrentUser) {
    const user: Partial<User> = currentUser || (window && window.currentUser) || null;
    return !!(user && user.isPerTailAdmin);
}

export function isUserAllocationAdmin(currentUser?: CurrentUser) {
    const user: Partial<User> = currentUser || (window && window.currentUser) || null;
    return !!(user && user.isUserAllocationAdmin);
}

export function isMfbInternational(currentUser?: CurrentUser) {
    const user: Partial<User> = currentUser || (window && window.currentUser) || null;
    return user && user.isMfbInternational;
}

export function isMfbOneInternational(currentUser?: CurrentUser) {
    const user: Partial<User> = currentUser || (window && window.currentUser) || null;
    return user && user.mfb_one_intl;
}

export function isInvoiceAdmin(currentUser?: CurrentUser) {
    const user: Partial<User> = currentUser || (window && window.currentUser) || null;
    return !!(user && user.isInvoiceAdmin);
}

export function hasRaimPrediction(currentUser?: CurrentUser) {
    const user: Partial<User> = currentUser || (window && window.currentUser) || null;
    return !!(user && user.raim_prediction);
}

export function hasReserveFuelPolicy(currentUser?: CurrentUser) {
    const user: Partial<User> = currentUser || (window && window.currentUser) || null;
    return !!(user && user.reserve_fuel_policy);
}

export function hasJetFuelX(currentUser?: CurrentUser) {
    const user: Partial<User> = currentUser || (window && window.currentUser) || null;
    if (!user) return false;
    return !!user.jetfuelx;
}

export function isOrgJfxEditor(currentUser?: CurrentUser) {
    const user: Partial<User> = currentUser || (window && window.currentUser) || null;
    return !!(user && user.isOrgJfxEditor);
}

export function hasCanadianLicense(currentUser?: CurrentUser) {
    const user: Partial<User> = currentUser || (window && window.currentUser) || null;
    if (!user) return false;
    return !!user.data_ca;
}

export function hasEuLicense(currentUser?: CurrentUser) {
    const user: Partial<User> = currentUser || (window && window.currentUser) || null;
    if (!user) return false;
    return !!user.data_eu;
}

export function hasAuLicense(currentUser?: CurrentUser) {
    const user: Partial<User> = currentUser || (window && window.currentUser) || null;
    if (!user) return false;
    return !!user.data_au;
}

export function hasUsLicense(currentUser?: CurrentUser) {
    const user: Partial<User> = currentUser || (window && window.currentUser) || null;
    if (!user) return false;
    return !!user.data_us;
}

export function hasCompliance(currentUser?: CurrentUser) {
    const user: Partial<User> = currentUser || (window && window.currentUser) || null;
    if (!user) return false;
    return !!user.comply;
}

export function isFeatureEnabled(feature: string) {
    return (
        (window && window.featureFlags && window.featureFlags[feature]) || false
    );
}

/**
 * Returns true when the new BA licensing model is active (`pacman` is set on
 * the user AND the `ba_new_tier_model` feature flag is on).
 * All BA platform-tier gating is conditional on this.
 */
export function hasPlatformTierLicensing(currentUser?: CurrentUser): boolean {
    const user: Partial<User> = currentUser || (window && window.currentUser) || null;
    if (!user) return false;
    return !!user.pacman && isFeatureEnabled('ba_new_tier_model');
}

// NOTE: Use this method for unit tests only!
export function setFeatureFlagForTest(feature: string, status: boolean = false) {
    try {
        window.featureFlags = {[feature]: status}
    } catch (e) {
        console.error(e);
    }
}

export function isManagingAccount(currentUser?: CurrentUser) {
    const user: Partial<User> = currentUser || (window && window.currentUser) || null;
    if (!user) return false;
    return !cookies.hasItem("local_dev_login_as") && !!user.fspAdminUuid;
}

export function isLoggedInFromCenter(serverEnv?: ServerEnv) {
    let keyName = `fflogged_in_from_center`;
    const isQa = window.location?.host?.includes("qa");
    const env = serverEnv || window.serverEnv || (isQa ? "qa" : "prod");

    if(env !== "prod")
        keyName += `_${env}`;
    return cookies.hasItem(keyName);
}

export function isFlightServiceProviderAdmin(currentUser?: CurrentUser) {
    const user: Partial<User> = currentUser || (window && window.currentUser) || null;
    if (!user) return false;
    return user.isFspAdmin;
}

export function hasFsp(currentUser?: CurrentUser) {
    const user: Partial<User> = currentUser || (window && window.currentUser) || null;
    if (!user) return false;
    return user.isFsp;
}

export function hasPerUserLicense(currentUser?: CurrentUser) {
    const user: Partial<User> = currentUser || (window && window.currentUser) || null;
    if (!user) return false;
    return user.hasPerUserLicense;
}
export function hasRunwayAnalysisTools(currentUser?: CurrentUser) {
    const user: Partial<User> = currentUser || (window && window.currentUser) || null;
    if (!user) return false;
    return user.runway_analysis_tools;
}
export function hasRunwayAnalysisAddOnForIndividualAccount(currentUser?: CurrentUser) {
    const user: Partial<User> = currentUser || (window && window.currentUser) || null;
    if (!user) return false;
    return Object.keys(user).some((field:string) =>
        field.startsWith('runway_analysis') && field !== 'runway_analysis_tools'
    );
}

export function hasDispatchAddOn(currentUser?: CurrentUser) {
    const user: Partial<User> = currentUser || (window && window.currentUser) || null;
    if (!user) return false;
    return Object.keys(user).some((field:string) =>
        field.startsWith('dispatch')
    );
}
export function hasLicense(license: keyof CurrentUser | RegExp, user = window.currentUser) {
    if (!user) return false;
    if (license instanceof RegExp) {
        return Boolean(Object.entries(user).find(([key, value]) => value && license.exec(key)));
    } else {
        return Boolean(user[license]);
    }
}

export function hasSupport(currentUser?: CurrentUser) {
    const user: Partial<User> = currentUser || (window && window.currentUser) || null;
    if (!user) return false;
    return user.isProSupport || user.isPremiumSupport;
}

export function isLegacyAccount(currentUser?: CurrentUser) {
    const user: Partial<User> = currentUser || (window && window.currentUser) || null;

    return (user?.isLegacyAccount)
}

export function hasJeppesenDispatch(currentUser?: CurrentUser) {
    const user: Partial<User> = currentUser || (window && window.currentUser) || null;
    if (!user) return false;
    return user.hasDispatchLowca || user.hasJeppesenMaDispatch;
}

export function hasBusinessPerformancePlan(currentUser?: CurrentUser) {
    const user: Partial<User> = currentUser || (window && window.currentUser) || null;
    if (!user) return false;
    return user.business_performance;
}

export function hasFlitelinkPreferred(currentUser?: CurrentUser) {
    const user: Partial<User> = currentUser || (window && window.currentUser) || null;
    if (!user) return false;
    return user.flitebrief || user.flitelink_preferred;
}

export function hasFlitelinkEssential(currentUser?: CurrentUser) {
    const user: Partial<User> = currentUser || (window && window.currentUser) || null;
    if (!user) return false;
    return user.flitelink || user.flitelink_essential;
}

export function hasInsurance(currentUser?: CurrentUser) {
    const user: Partial<User> = currentUser || (window && window.currentUser) || null;
    return !!(user && user.hasInsurance)
}

export function hasInsuranceOwnerQuoting(currentUser?: CurrentUser) {
    const user: Partial<User> = currentUser || (window && window.currentUser) || null;
    return !!(user && user.hasInsuranceOwnerQuoting);
}

export function hasEasaCompliance(currentUser?: CurrentUser) {
    const user: Partial<User> = currentUser || (window && window.currentUser) || null;
    return !!(user && user.easa_compliance);
}

export function hasWbUseDryOperatingWeight(currentUser?: CurrentUser) {
    const user: Partial<User> = currentUser || (window && window.currentUser) || null;
    return !!(user && user.wb_use_dry_operating_weight);
}

export function isInSubOrg(currentUser?: CurrentUser) {
    const user: Partial<User> = currentUser || (window && window.currentUser) || null;
    return !!(user && user.isInSubOrg);
}

export function isAllTiers(currentUser?: CurrentUser) {
    const user: Partial<User> =
        currentUser || (window && window.currentUser) || null;
    if (!user) return false;
    return (
        user.basic_plus ||
        user.pro_plus ||
        user.performance_plus ||
        user.business_pro ||
        user.business_performance ||
        user.mfb_pro ||
        user.mfb_performance ||
        user.mfb_pro_intl ||
        user.mfb_one ||
        user.mfb_perf_intl ||
        user.dispatch_tools
    );
}

export function hasDynamicProcedures(currentUser?: CurrentUser) {
    const user: Partial<User> = currentUser || (window && window.currentUser) || null;
    return !!(user && user.dynamic_procedures_group_enablement);
}

export function hasReportedTurbulenceAll(currentUser?: CurrentUser) {
    const user: Partial<User> = currentUser || (window && window.currentUser) || null;
    return !!(user && user.licenseReportedTurbulenceAll);
}

export function hasReportedTurbulenceLowAlt(currentUser?: CurrentUser) {
    const user: Partial<User> = currentUser || (window && window.currentUser) || null;
    return !!(user && user.licenseReportedTurbulenceLowAlt);
}

export function hasAnyReportedTurbulence(currentUser?: CurrentUser) {
    const user: Partial<User> = currentUser || (window && window.currentUser) || null;
    return !!(user && user.hasAnyReportedTurbulence);
}

export function hasTrackingRole(currentUser?: CurrentUser) {
    const user: Partial<User> = currentUser || (window && window.currentUser) || null;
    return !!(user && user.hasTrackingRole);
}

export function hasTrackingLicense(currentUser?: CurrentUser) {
    const user: Partial<User> = currentUser || (window && window.currentUser) || null;
    return !!(user && (user.flight_tracking || user.flight_tracking_global || user.mil_flight_tracking_standard || user.mil_flight_tracking_enhanced || user.mil_flight_tracking_premium || user.ca_flight_tracking_essential || user.ca_flight_tracking_preferred));
}

export function hasCATrackingLicense(currentUser?: CurrentUser) {
    const user: Partial<User> = currentUser || (window && window.currentUser) || null;
    return !!(user && (user.ca_flight_tracking_essential || user.ca_flight_tracking_preferred));
}

export function hasFratLicense(currentUser?: CurrentUser) {
    const user: Partial<User> = currentUser || (window && window.currentUser) || null;
    return !!(user && user.frat);
}

export function isSafetyManager(currentUser?: CurrentUser) {
    const user: Partial<User> = currentUser || (window && window.currentUser) || null;
    return !!(user && user.isSafetyManager);
}

export function isResellerCustomer(currentUser?: CurrentUser) {
    const user: Partial<User> = currentUser || (window && window.currentUser) || null;
    return !!(user && user.reseller_customer);
}

export function hasSmsLicense(currentUser?: CurrentUser) {
    const user: Partial<User> = currentUser || (window && window.currentUser) || null;
    return !!(user && user.hasSms);
}

declare global {
    interface Window {
        isActive: boolean;
    }
}

/**
 * Returns T/F if the user has an active subscription. Note this is supplied from the backend
 * and includes the 7 day grace period after the subscription has ended/expired.
 * (Thats to say if its been 6 days since the subscription expired this function
 * will still return T)
 */
export function isActiveSubscription() {
    return window.isActive ?? false;
}
